import { render } from "./ExhibitionCarousel.vue?vue&type=template&id=781ef84d"
import script from "./ExhibitionCarousel.vue?vue&type=script&lang=js"
export * from "./ExhibitionCarousel.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Administrator\\Desktop\\market\\front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__